"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBusinessGroupFromShopType = void 0;
const bookingTypes_1 = require("../types/bookingTypes");
function getBusinessGroupFromShopType(shopType) {
    const shopGroups = {
        [bookingTypes_1.BookingBusinessGroup.COMMON_STUFF]: [
            bookingTypes_1.BookingShopType.FURNITURE_STORE,
            bookingTypes_1.BookingShopType.STATIONERY,
            bookingTypes_1.BookingShopType.TOY_STORE,
        ],
        [bookingTypes_1.BookingBusinessGroup.MAIN_DISHES]: [
            bookingTypes_1.BookingShopType.RESTAURANT,
            bookingTypes_1.BookingShopType.FRESH_FOOD,
        ],
        [bookingTypes_1.BookingBusinessGroup.APPETIZERS]: [bookingTypes_1.BookingShopType.BAKERY],
        [bookingTypes_1.BookingBusinessGroup.CLINIC]: [
            bookingTypes_1.BookingShopType.PHARMACY,
            bookingTypes_1.BookingShopType.CLINIC,
            bookingTypes_1.BookingShopType.OPTIC_SHOP,
        ],
        [bookingTypes_1.BookingBusinessGroup.SPECIALTY]: [
            bookingTypes_1.BookingShopType.ELECTRONICS_STORE,
            bookingTypes_1.BookingShopType.MOBILE_ACCESSORIES,
            bookingTypes_1.BookingShopType.JEWELRY_SHOP,
        ],
        [bookingTypes_1.BookingBusinessGroup.LIFESTYLE]: [
            bookingTypes_1.BookingShopType.BOOKSTORE,
            bookingTypes_1.BookingShopType.FLOWER_SHOP,
            bookingTypes_1.BookingShopType.BEAUTY_SALON,
        ],
        [bookingTypes_1.BookingBusinessGroup.FASHION]: [
            bookingTypes_1.BookingShopType.GIFT_SHOP,
            bookingTypes_1.BookingShopType.CLOTHING_STORE,
            bookingTypes_1.BookingShopType.BAG_SHOP,
        ],
        [bookingTypes_1.BookingBusinessGroup.OTHERS]: [bookingTypes_1.BookingShopType.OTHER],
        [bookingTypes_1.BookingBusinessGroup.DRINK_SHOP]: [bookingTypes_1.BookingShopType.DRINK_SHOP],
    };
    let businessGroup = null;
    Object.keys(shopGroups).forEach((group) => {
        const filterResult = shopGroups[group].filter((type) => type === shopType);
        if (filterResult.length) {
            businessGroup = group;
        }
    });
    return businessGroup;
}
exports.getBusinessGroupFromShopType = getBusinessGroupFromShopType;
//# sourceMappingURL=bookingUtils.js.map